import ApplicationGroupIndividualsModal from "./ApplicationGroupIndividualsModalContainer";

export default ApplicationGroupIndividualsModal;
